import { useQuery } from '@tanstack/react-query';
import { dashboardService } from '../services/dashboardService';

export const useDashboardStats = () => {
  return useQuery({
    queryKey: ['dashboard', 'stats'],
    queryFn: dashboardService.getStats,
    refetchInterval: 30000, // Refetch every 30 seconds
    retry: 3, // 3 kez tekrar dene
    retryDelay: 1000, // Her deneme arasında 1 saniye bekle
  });
};

